/* ===== 苹果风格交互效果 JS ===== */

(function () {
  'use strict';

  // ---- 1. 文字淡入动画（Intersection Observer）----
  function initFadeInAnimations() {
    const targets = document.querySelectorAll(
      '.shopify-section h1, .shopify-section h2, .shopify-section h3, ' +
      '.shopify-section p, .shopify-section .button, ' +
      '.collection-list__item, .card-wrapper, .product-card-wrapper'
    );

    targets.forEach(function (el) {
      el.classList.add('apple-fade-in');
    });

    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -50px 0px' }
    );

    targets.forEach(function (el) {
      observer.observe(el);
    });
  }

  // ---- 2. 视差滚动效果 ----
  function initParallax() {
    const heroSection = document.querySelector('.hero, [class*="hero-banner"], .banner');
    if (!heroSection) return;

    const heroImg = heroSection.querySelector('img, .banner__media');
    if (!heroImg) return;

    heroImg.classList.add('apple-parallax-img');
    heroSection.classList.add('apple-parallax-wrapper');

    let ticking = false;

    window.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(function () {
          const scrollY = window.pageYOffset;
          const heroHeight = heroSection.offsetHeight;

          if (scrollY < heroHeight) {
            const parallaxOffset = scrollY * 0.4;
            heroImg.style.transform = 'scale(1.15) translateY(' + parallaxOffset + 'px)';
          }

          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  }

  // ---- 3. 磨砂玻璃导航 ----
  function initStickyNav() {
    const nav = document.querySelector(
      'header, .header, #shopify-section-header, [class*="header"]'
    );
    if (!nav) return;

    let ticking = false;

    window.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(function () {
          if (window.pageYOffset > 50) {
            nav.classList.add('apple-nav-blur');
          } else {
            nav.classList.remove('apple-nav-blur');
          }
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  }

  // ---- 初始化 ----
  function init() {
    // 检查是否支持 IntersectionObserver
    if ('IntersectionObserver' in window) {
      initFadeInAnimations();
    }

    initParallax();
    initStickyNav();
  }

  // DOM 加载完成后执行
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
